export default __webpack_public_path__ + "static/media/researchGB.fdb45a30.png";